<template>
  <div class="input-select">
    <v-select
      attach
      hide-details
      v-bind:class="[inputClass, { 'input-select-custom': needUseCustomItem }]"
      v-bind:disabled="disabled"
      v-bind:menu-props="menuProps"
      v-bind:item-text="optionTitleKey"
      v-bind:item-value="optionValueKey"
      v-bind:items="options"
      v-bind:label="title"
      v-bind:value="value"
      v-on:input="$emit('input', $event)"
    >
      <template v-if="needUseCustomItem" v-slot:selection="{ item }">
        <div class="input-select-custom__selection">
          <p class="input-select-custom__value primary--text">
            {{ item[optionTitleKey] }}
          </p>
          <span
            v-if="item[optionDescriptionKey]"
            class="input-select-custom__description grey--text">
            {{ item[optionDescriptionKey] }}
          </span>
        </div>
      </template>
      <template v-if="needUseCustomItem" v-slot:item="{ item, attrs, on }">
        <v-list-item v-bind="attrs" v-on="on">
          <v-list-item-content class="custom-items input-select-custom__items">
            <v-list-item-title class="primary--text">
              {{ item[optionTitleKey] }}
            </v-list-item-title>
            <v-list-item-subtitle class="custom-items__description grey--text">
              {{ item[optionDescriptionKey] }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
    <p
      class="violation"
      role="alert"
      v-for="violationText in violations"
      v-bind:key="violationText"
    >{{ violationText }}</p>
  </div>
</template>

<script>

/**
 * @description Поле выбора.
 * @type {Vue}
 */
export default {
  name: 'InputSelect',
  props: {
    /**
     * @description Деактивирован.
     * @type {boolean}
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Дополнительные настройки v-menu.
     * @type {any}
     */
    menuProps: { default: () => {}, type: [String, Array, Object] },
    /**
     * @description Выбранное значение.
     * @type {any}
     */
    value: { default: () => null, type: [Number, String, Object] },
    /**
     * @description Ключ заголовка опции.
     * @type {string}
     */
    optionTitleKey: {
      default: () => 'title',
      type: String,
    },
    /**
     * @description Ключ значения опции.
     * @type {string}
     */
    optionValueKey: {
      default: () => 'value',
      type: String,
    },
    /**
     * @description Ключ описания опции.
     * @type {string}
     */
    optionDescriptionKey: {
      default: () => 'description',
      type: String,
    },
    /**
     * @description Опции.
     * @type {any[]}
     */
    options: {
      default: () => [],
      type: Array,
    },
    /**
     * @description Заголовок.
     * @type {string}
     */
    title: {
      required: true,
      type: String,
    },
    /**
     * @description Список нарушений.
     * @type {string[]}
     */
    violations: {
      default: () => [],
      type: Array,
    },
    inputClass: {
      default: '',
      type: String,
    },
    needUseCustomItem: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss">
.input-select {
  & .input-select-custom {
    .v-input__slot {
      &::before,
      &::after {
        content: none;
      }
    }
    .v-input__icon {
      .v-icon::before {
        content: "";
        width: 14px;
        height: 8px;
        mask-image: url("@/assets/img/checked/checked-grey.svg");
        mask-repeat: no-repeat;
        mask-position: center;
        mask-size: contain;
        background-color: grey;
        cursor: pointer;
      }
    }
    &.v-select--is-menu-active {
      .v-input__icon .v-icon::before {
        background-color: var(--action-color);
      }
    }
    .v-select__selections {
      flex-wrap: nowrap;
      min-height: 32px;
    }
    &__selection {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding-inline-start: 16px;
      overflow: hidden;
      & + input {
        max-width: 0;
        max-height: 0;
      }
    }
    &__description {
      position: relative;
      max-width: 200px;
      font-size: 12px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      &::after {
        content: '';
        position: absolute;
        inset: 0;
        left: auto;
        width: 25px;
        background: linear-gradient(
          270deg, #ffffff 25%,
          rgba(255, 255, 255, 0) 100%);
      }
    }

    .custom-items {
      &__description {
        white-space: normal;
      }
    }
  }
}
.violation {
  color: var(--warning-color);
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  padding: .125rem;
}

@media screen and (max-width: 960px) {
  .input-select {
    & .input-select-custom {
      .v-menu__content {
        max-width: 282px !important;
      }
      .v-input__icon {
        .v-icon::before {
          background-color: var(--fill-color) !important;
        }
      }
      &__selection {
        row-gap: 4px;
        padding: 0;
      }
      &__value {
        color: var(--fill-color) !important;
      }
      &__description {
        max-width: 325px;
        &::after {
          width: 45px;
          background: linear-gradient(
            270deg, #323C47 25%,
            rgba(255, 255, 255, 0) 100%);
        }
      }
    }
  }
}
</style>
